const rTabs = str => str.trim().replace(/^ {4}/gm, '');

export default rTabs;
